import { z } from 'zod';
import { FlowDurationUnits } from '../../../duration/duration.js';
import { FlowDurationSchemaWithMax } from '../../../duration/withMax.js';
import { BaseFlowBlockSchema } from '../block.js';
import { FlowBlockType } from '../type.js';
export const FlowCallbackBlockSchema = BaseFlowBlockSchema.extend({
    type: z.literal(FlowBlockType.Callback),
    config: z.object({
        message: z.string(),
        waitTime: FlowDurationSchemaWithMax({
            pathName: 'waitTime',
            max: { value: 30, units: FlowDurationUnits.Minutes },
        }),
        timeout: FlowDurationSchemaWithMax({
            pathName: 'timeout',
            max: { value: 1, units: FlowDurationUnits.Hours },
        }),
    }),
});
//# sourceMappingURL=config.js.map